///
/// EarthBrowser
///
/// Created by Matt Giger on 10/23/2026
/// Copyright (c) 2026 Geodata Labs
///
/// v54 -> v55: Add legends to the userInterface slice (persisted legend
/// tray state: per-layer expanded / chip / hidden plus the legend the
/// tray auto-opened last). Replaces the per-legend
/// "earthbrowser-*-legend-collapsed" localStorage keys, which are dropped.
/// Rehydrate replaces the slice wholesale, so existing users need the
/// field seeded.
///

const cLegacyCollapsedKeys = [
	"earthbrowser-sst-legend-collapsed",
	"earthbrowser-synoptic-legend-collapsed",
	"earthbrowser-wildfire-legend-collapsed",
]

export function migrateV54toV55(state: unknown): unknown {
	try {
		for (const key of cLegacyCollapsedKeys) {
			localStorage.removeItem(key)
		}
	} catch {
		// localStorage unavailable; nothing to clean up
	}

	const s = state as Record<string, unknown> | null | undefined
	if (!s || typeof s !== "object") return state

	const userInterface = s.userInterface as Record<string, unknown> | undefined
	if (!userInterface || userInterface.legends) return state

	return {
		...s,
		userInterface: {
			...userInterface,
			legends: { display: {}, autoExpanded: null },
		},
	}
}
